import React, { ReactElement, useState } from 'react';
import * as Sentry from '@sentry/react';
import { Alert } from 'antd';
import { Outlet } from 'react-router-dom';

export const ErrorBoundary = (): ReactElement => {
  const [err, setErr] = useState<null | { error: Error; componentStack: string }>(null);
  const onError = (error: Error, componentStack: string): void => {
    setErr({ error, componentStack });
  };
  return (
    <Sentry.ErrorBoundary
      onError={onError}
      fallback={
        <Alert showIcon message="General error" description={String(err?.error)} type="error" style={{ margin: 20 }} />
      }
      showDialog
    >
      <Outlet />
    </Sentry.ErrorBoundary>
  );
};
